import type { CarouselBannerModel } from "src/features/HomepageCarouselBanners/models";

import { useQuery } from "@tanstack/react-query";
import { camelizeKeys } from "humps";
import { cmsClient } from "src/services/cmsClient";

interface Options {
	enabled?: boolean;
}

export const fetchCarouselBanner = async (id: number) => {
	const url = `/homepage/admin/carouselbanner/${id}/`;

	const { data } = await cmsClient.get(url);
	return data;
};

const useCarouselBanner = (
	id: number,
	options: Options = { enabled: true }
) => {
	const enabled = options.enabled;

	const queryKey = ["carousel-banner", id];
	const queryFn = () => fetchCarouselBanner(id);

	const select = (data: CarouselBanner) => {
		const adaptedData = camelizeKeys(data) as CarouselBannerModel;

		return adaptedData;
	};

	const query = useQuery({
		queryKey,
		queryFn,
		enabled,
		select
	});

	return query;
};

export default useCarouselBanner;
